module.exports = __webpack_public_path__ + "6ce39eb39e4493127dd79d38e17090b1.png";